module.exports = __webpack_public_path__ + "static/img/8.163ecb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/8.jpg
// module id = KM6E
// module chunks = 0